import React from "react";
import clsx from 'clsx';
import { FieldConfig } from '@xem/look/FieldConfig';
import Field from '@gqlapp/forms-client-react/FieldAdapter';
import Button from "reactstrap/lib/Button";
import countries from "@gqlapp/config/country/countries";
import getPhoneValues from "@gqlapp/base/utils/getPhoneValues";
import countryToPath from '@xem/entity/classes/countryToPath';
import { WrapControler } from "@gqlapp/base/FieldWrap";
import Box from "@mui/material/Box";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import opt from "@gqlapp/base/utils/opt";
import {withFormik} from "formik";
import Dropdown from "../icons/Dropdown.svg";
import RenderField from "../Field";

function PhoneForm(props: any){

  let { mask, label, onActions, setFieldValue, setValues, values, inputProps } = props
  const {  area, code, phoneNumber } = values;

  /**
   *
   */
  return (<>
    <Row mini>
      <Col xs={'auto'} className={'phone-country'}>
        <Box sx={{ '.btn': { padding: 0, fontSize:  '30px' }}}>
          <Button color={'default'} onClick={()=>onActions?.country({
            country: area,
            title: 'user:popup.country'.t(),
            onChange: (area: string) => {
              let { phone: code } = opt(countries, area);
              setValues({ ...values, code, area });
            }
          })}>
            {countryToPath(area)}
            &nbsp;<Dropdown className={'dropdown-arrow'} />
          </Button>
        </Box>
      </Col>
      <Col className={'phone-number'}>
        <FieldConfig
          {...{ onRemove: setFieldValue, component: RenderField }}
          {...{ size: 1, inputProps: inputProps || { tabIndex: 1 } }}
          {...{ mask: mask || ['0', /[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/] }}
          {...{ label: label || 'user:userEdit.form.field.phone'.t() }}
          {...{ name: 'phoneNumber', value: phoneNumber }}
          startAdornment={ phoneNumber ? <Box sx={{ whiteSpace: 'nowrap'  }}>+{code}</Box>: null}
        />
      </Col>
    </Row>
  </>)
}

let timeout: any;

/**
 *
 * @param code
 * @param phoneNumber
 * @param name
 * @param onChange
 */
function validate({ code, phoneNumber }, { name, onChange }){
  clearTimeout(timeout);
  if(phoneNumber) {
    timeout = setTimeout(() => {
      onChange && onChange(name, `+${code} ${phoneNumber}`)
    }, 50);
  }else{
    onChange && onChange(name, ``)
  }
}

/**
 *
 * @param value
 * @param country
 */
function mapPropsToValues({ value, options }: any) {
  let area: string, code: string, phoneNumber: string;
  ({ area, code, phoneNumber } = getPhoneValues(value, options));
  return ({ area, code, phoneNumber })
}

/**
 *
 */
const DataForm = withFormik({
  enableReinitialize: false,
  displayName: `PhoneForm`,
  handleSubmit: async ({ }: any, {}: any) => {},
  mapPropsToValues,
  validate
});

const Phone = DataForm(PhoneForm);

const PhoneField = (props: any) =>{
  let { sx, name } = props
  return <Box sx={sx} className={clsx(props?.className, 'phone-wrapper')}>
    <Field {...{ component: WrapControler }} name={name}>
      <Phone {...props} />
    </Field>
  </Box>
}
export default PhoneField;